const metricSectionTestIDs = {
  metricSectionClientsOverview: 'metric-section-clients-overview',
  metricSectionCandidates: 'metric-section-candidates',
  metricSectionSharePlan: 'metric-section-share-plan',
  metricSectionCoaches: 'metric-section-coaches',
  metricSectionTeamsOverview: 'metric-section-teams-overview',
  metricSectionExpiring: 'metric-section-expiring',
  metricSectionClientsToContact: 'metric-section-clients-to-contact',
  metricSectionShareCart: 'metric-section-share-cart',
  metricSectionOrdersMetric: 'metric-section-orders-metrics',
  metricSectionProjectedPremierVolume:
    'metric-section-projected-premier-volume',
  metricSectionCoachesToCelebrate: 'metric-section-coaches-to-celebrate',
  metricSectionRankPerformance: 'metric-section-rank-performance',
  metricSectionCloseToCompetency: 'metric-section-close-to-competency',
  metricSectionBonuses: 'metric-section-bonuses',
  metricSectionNeedAttention: 'metric-section-need-attention',
  metricSectionPersonalPerformanceMetrics:
    'metric-section-personal-performance-metrics',
  metricSectionEarnings: 'metric-section-earnings',

  metricSectionTitle: 'metric-section-title',
  metricTitle: 'metric-title',
  metricSubTitle: 'metric-subtitle',
  metricValue: 'metric-value',
  metricDelta: 'metric-delta',

  metricNewFrontlineClients: 'metric-new-frontline-clients',
  metricAllFrontlineClients: 'metric-all-frontline-clients',
  metricNewGeneration0Clients: 'metric-new-generation-0-clients',
  metricAllGeneration0Clients: 'metric-all-generation-0-clients',
  metricNewOrganizationClients: 'metric-new-organization-clients',
  metricAllOrganizationClients: 'metric-all-organization-clients',

  metricAllCandidates: 'metric-all-candidates',
  metricSharePlanButton: 'metric-share-plan-button',
  metricSharePlanButtonLabel: 'metric-share-plan-button-label',
  metricSharePlanButtonIcon: 'metric-share-plan-button-icon',

  metricFrontlineCoaches: 'metric-frontline-coaches',
  metricNewFrontlineCoaches: 'metric-new-frontline-coaches',
  metricAllFrontlineCoaches: 'metric-all-frontline-coaches',
  metricNewGeneration0Coaches: 'metric-new-generation-0-coaches',
  metricAllGeneration0Coaches: 'metric-all-generation-0-coaches',
  metricNewOrganizationCoaches: 'metric-new-organization-coaches',
  metricAllOrganizationCoaches: 'metric-all-organization-coaches',

  metricSeniorCoachTeams: 'metric-senior-coach-teams',
  metricExecutiveDirectorTeams: 'metric-executive-director-teams',
  metricFIBCTeams: 'metric-FIBC-teams',
  metricFIBLTeams: 'metric-FIBL-teams',

  metricFrontlineClientsExpiringRewards:
    'metric-frontline-clients-expiring-rewards',
  metricOrganizationClientsExpiringWellnessCredits:
    'metric-organization-clients-expiring-wellness-credits',

  metricPremierCancellations: 'metric-premier-cancellations',
  metricNewClientsWithoutOrders: 'metric-new-clients-without-orders',
  metricInactiveClients: 'metric-inactive-clients',

  metricNewFrontlineOrders: 'metric-new-frontline-orders',
  metricAllFrontlineOrders: 'metric-all-frontline-orders',
  metricAllFrontlineOrdersNew: 'metric-all-frontline-orders-new',
  metricNewGeneration0Orders: 'metric-new-generation-0-orders',
  metricAllGeneration0Orders: 'metric-all-generation-0-orders',
  metricAllGeneration0OrdersNew: 'metric-all-generation-0-orders-new',
  metricNewOrganizationOrders: 'metric-new-organization-orders',
  metricAllOrganizationOrders: 'metric-all-organization-orders',
  metricAllOrganizationOrdersNew: 'metric-all-organization-orders-new',

  metricCurrentMonthToDateVolume: 'metric-current-month-to-date-volume',
  metricProjectedPremierVolume: 'metric-projected-premier-volume',
  metricProjectedFrontlineVolume: 'metric-projected-frontline-volume',
  metricProjectedGeneration0Volume: 'metric-projected-generation-0-volume',
  metricProjectedTotalGenerationVolume:
    'metric-projected-total-generation-volume',

  metricRankUp: 'metric-rank-up',
  metricEarnedClientAcquisitionBonus: 'metric-earned-client-acquisition-bonus',
  metricEarnedClientSupportBonusPlus: 'metric-earned-client-support-bonus-plus',
  metricEarnedQuickStartBonus: 'metric-earned-quick-start-bonus',
  metricEarnedCoachAcceleratorBonus: 'metric-earned-coach-accelerator-bonus',
  metricQualifiedForIncentiveTrip: 'metric-qualified-for-incentive-trip',

  metricAboveRank: 'metric-above-rank',
  metricAtRank: 'metric-at-rank',
  metricBelowRank: 'metric-below-rank',

  metricCloseToSeniorCoach: 'metric-close-to-senior-coach',
  metricCloseToExecutiveDirector: 'metric-close-to-executive-director',
  metricCloseFIBC: 'metric-close-to-FIBC',

  metricEligibleForCAB: 'metric-eligible-for-CAB',
  metricEligibleForAB: 'metric-eligible-for-AB',
  metricEligibleForQSB: 'metric-eligible-for-QSB',
  metricEligibleForCSBP: 'metric-eligible-for-CSBP',

  metricQualifiedForCSBP_One_Two: 'metric-qualified-for-CSBP-One-Two',
  metricQualifiedForCSBP_Three_Four: 'metric-qualified-for-CSBP-Three-Four',
  metricQualifiedForCSBP_Five_Six: 'metric-qualified-for-CSBP-Five-Six',
  metricQualifiedForCSBP_Seven_Nine: 'metric-qualified-for-CSBP-Seven-Nine',
  metricQualifiedForCSBPlus: 'metric-qualified-for-CSBP',
  metricEligibleForIncentiveTrip: 'metric-eligible-for-IT',

  metricNotCertified: 'metric-not-certified',
  metricExpiringCoachRenewals: 'metric-expiring-coach-renewals',

  metricFrontlineQualifyingVolume: 'metric-frontline-qualifying-volume',
  metricGeneration0Volume: 'metric-generation-0-volume',
  metricTotalGenerationVolume: 'metric-total-generation-volume',
  metricOrderingEntities: 'metric-ordering-entities',
  metricQualifyingPoints: 'metric-qualifying-points',

  metricCommission: 'metric-commission',
  metricBonuses: 'metric-bonuses',
  metricTotalIncome: 'metric-total-income',
  metricNewCounter: 'metric-new-counter',
  addCandidateButton: 'metric-candidates-add-candidates-button',
};

export default metricSectionTestIDs;
